export default __webpack_public_path__ + "static/media/warning.9d264b88.svg";